import { type ReactNode } from 'react'
import { type IntlShape } from 'react-intl'

import { priceGetFormattedPrice } from '../../../price'

export const shippingAccessorGetFormattedShippingTypeCost = ({
  intl,
  isFreeShipping,
  shippingTypeCode,
  totalShippingPrice,
}: {
  intl: IntlShape
  isFreeShipping: boolean
  shippingTypeCode?: string | null
  totalShippingPrice?: number | null
}): ReactNode => {
  const deliveryPrice = {
    price:
      typeof totalShippingPrice !== 'number' ||
      totalShippingPrice === 0 ||
      isFreeShipping
        ? 0
        : priceGetFormattedPrice(totalShippingPrice, intl),
  }

  switch (shippingTypeCode) {
    case 'express': {
      return intl.formatMessage(
        {
          id: 'buyBox.delivery.expressPrice',
        },
        deliveryPrice,
      )
    }
    case 'sameday': {
      return intl.formatMessage(
        {
          id: 'buyBox.delivery.samedayPrice',
        },
        deliveryPrice,
      )
    }
    case 'standard': {
      return intl.formatMessage(
        {
          id: 'buyBox.delivery.standardPrice',
        },
        deliveryPrice,
      )
    }
    default: {
      return intl.formatMessage(
        {
          id: 'buyBox.delivery.forwardAgencyPrice',
        },
        deliveryPrice,
      )
    }
  }
}
